import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-361582a2")

_pushScopeId("data-v-361582a2")
const _hoisted_1 = {
  key: 0,
  class: "px-4 py-6"
}
const _hoisted_2 = {
  key: 1,
  class: "px-4 py-6"
}
const _hoisted_3 = { class: "sticky top-0 bg-white z-20" }
const _hoisted_4 = { class: "text-14px text-gray-lp-300 border-b" }
const _hoisted_5 = { key: 4 }
const _hoisted_6 = {
  key: 2,
  class: "bg-white border-t px-2"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TableLazyLoad = _resolveComponent("TableLazyLoad")!
  const _component_EmptyList = _resolveComponent("EmptyList")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_PaginationV3 = _resolveComponent("PaginationV3")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("div", {
    class: "courier-table-wrap",
    style: { height: _ctx.heightCalc }
  }, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_TableLazyLoad, {
          key: 0,
          columns: _ctx.columns
        }, null, 8, ["columns"]))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          (_ctx.isFiltering && (_ctx.data || []).length === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                _createVNode(_component_EmptyList, {
                  icon: "ill_spot_search",
                  customHeaderMessage: 
              _ctx.$t('pickupDashboard.emptyState.searchNotFound')
            ,
                  customMessage: _ctx.$t('pickupDashboard.emptyState.searchNotFoundHint')
                }, null, 8, ["customHeaderMessage", "customMessage"])
              ]))
            : ((_ctx.data || []).length === 0)
              ? (_openBlock(), _createBlock("div", _hoisted_2, [
                  _createVNode(_component_EmptyList, {
                    data: "data",
                    customHeaderMessage: _ctx.$t('pickupDashboard.emptyState.noPackage'),
                    customMessage: _ctx.$t('pickupDashboard.emptyState.noPackageHint')
                  }, null, 8, ["customHeaderMessage", "customMessage"])
                ]))
              : (_openBlock(), _createBlock("div", {
                  key: 2,
                  class: "courier-table",
                  style: {
            maxHeight: `calc(calc(100vh / var(--viewport-scale)) - ${360}px)`
          }
                }, [
                  _createVNode("table", null, [
                    _createVNode("thead", _hoisted_3, [
                      _createVNode("tr", _hoisted_4, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                          return (_openBlock(), _createBlock("th", {
                            key: col.key,
                            class: _ctx.computeHeadClass(col),
                            onClick: ($event: any) => (
                    _ctx.headIsSortable(col) && _ctx.onSort(col.sortingKey || col.key)
                  )
                          }, [
                            _createVNode("div", {
                              class: _ctx.headWrapperClass(col)
                            }, [
                              (col.key === 'checkbox')
                                ? (_openBlock(), _createBlock("div", {
                                    key: 0,
                                    class: ["w-5 h-5 rounded flex items-center justify-center cursor-pointer", 
                          _ctx.isAllSelected
                            ? 'bg-red-lp-100'
                            : 'border border-gray-lp-400'
                        ],
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toggleSelectAll()), ["stop"]))
                                  }, [
                                    (_ctx.isAllSelected)
                                      ? (_openBlock(), _createBlock(_component_Icons, {
                                          key: 0,
                                          name: "check",
                                          class: "w-4 h-4 text-white"
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 2))
                                : (_ctx.$slots.head)
                                  ? _renderSlot(_ctx.$slots, "head", {
                                      key: 1,
                                      col: col,
                                      sortBy: _ctx.sortBy,
                                      sortDir: _ctx.sortDir,
                                      onSort: _ctx.onSort
                                    }, undefined, true)
                                  : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                                      _createVNode("span", null, _toDisplayString(_ctx.$t(col.name || col.label)), 1),
                                      (_ctx.headIsSortable(col))
                                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                            (
                            _ctx.sortBy === (col.sortingKey || col.key) &&
                              _ctx.sortDir === 'asc'
                          )
                                              ? (_openBlock(), _createBlock("img", {
                                                  key: 0,
                                                  src: 
                            require('@/app/ui/assets/svg/ics_o_chevron_sort_asc.svg')
                          ,
                                                  class: "w-4 h-4",
                                                  alt: "sort-asc"
                                                }, null, 8, ["src"]))
                                              : (
                            _ctx.sortBy === (col.sortingKey || col.key) &&
                              _ctx.sortDir === 'desc'
                          )
                                                ? (_openBlock(), _createBlock("img", {
                                                    key: 1,
                                                    src: 
                            require('@/app/ui/assets/svg/ics_o_chevron_sort_desc.svg')
                          ,
                                                    class: "w-4 h-4",
                                                    alt: "sort-desc"
                                                  }, null, 8, ["src"]))
                                                : (_openBlock(), _createBlock("img", {
                                                    key: 2,
                                                    src: 
                            require('@/app/ui/assets/svg/ics_o_chevron_sort.svg')
                          ,
                                                    class: "w-4 h-4",
                                                    alt: "sort"
                                                  }, null, 8, ["src"]))
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ], 64))
                            ], 2)
                          ], 10, ["onClick"]))
                        }), 128))
                      ])
                    ]),
                    _createVNode("tbody", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, i) => {
                        return (_openBlock(), _createBlock("tr", {
                          key: _ctx.rowKey(item, i),
                          class: "border-b"
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                            return (_openBlock(), _createBlock("td", {
                              key: col.key,
                              class: 
                    (col.styleBody || col.cellClass || 'px-4 py-2') +
                      ' ' +
                      (col.styleCustom || '')
                  
                            }, [
                              (
                      _ctx.$slots.cell && col.key !== 'checkbox' && col.key !== 'no'
                    )
                                ? (_openBlock(), _createBlock("div", {
                                    key: 0,
                                    class: _ctx.bodyWrapperClass(col)
                                  }, [
                                    _renderSlot(_ctx.$slots, "cell", {
                                      item: item,
                                      col: col,
                                      index: i,
                                      startIndex: _ctx.startIndex,
                                      isSelected: _ctx.isSelected(item),
                                      toggleSelect: () => _ctx.toggleSelect(item),
                                      onRowTransfer: () => _ctx.onRowTransfer(item)
                                    }, undefined, true)
                                  ], 2))
                                : (col.key === 'checkbox')
                                  ? (_openBlock(), _createBlock("div", {
                                      key: 1,
                                      class: ["w-5 h-5 rounded flex items-center justify-center", [
                        _ctx.isSelected(item)
                          ? 'bg-red-lp-100'
                          : 'border border-gray-lp-400',
                        _ctx.isCheckboxDisabled(item)
                          ? 'cursor-not-allowed opacity-50 bg-gray-lp-1800'
                          : 'cursor-pointer'
                      ]],
                                      onClick: _withModifiers(($event: any) => (
                        !_ctx.isCheckboxDisabled(item) && _ctx.toggleSelect(item)
                      ), ["stop"])
                                    }, [
                                      (_ctx.isSelected(item))
                                        ? (_openBlock(), _createBlock(_component_Icons, {
                                            key: 0,
                                            name: "check",
                                            class: "w-4 h-4 text-white"
                                          }))
                                        : _createCommentVNode("", true)
                                    ], 10, ["onClick"]))
                                  : (col.key === 'no')
                                    ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                                        _createTextVNode(_toDisplayString(_ctx.startIndex + i + 1), 1)
                                      ], 64))
                                    : (col.key === 'transfer' && !col.render)
                                      ? (_openBlock(), _createBlock("button", {
                                          key: 3,
                                          class: "border border-red-lp-100 text-red-lp-100 rounded px-3 py-1",
                                          onClick: _withModifiers(($event: any) => (_ctx.onRowTransfer(item)), ["stop"])
                                        }, _toDisplayString(_ctx.$t("pickupDashboard.transferPickUp")), 9, ["onClick"]))
                                      : (col.render)
                                        ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_5, null, 512)), [
                                            [_directive_sanitize_html, col.render(item, i)]
                                          ])
                                        : (_openBlock(), _createBlock(_Fragment, { key: 5 }, [
                                            _createTextVNode(_toDisplayString(item[col.key]), 1)
                                          ], 64))
                            ], 2))
                          }), 128))
                        ]))
                      }), 128))
                    ])
                  ])
                ], 4))
        ], 64)),
    (!_ctx.isLoading && (_ctx.data || []).length !== 0)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode(_component_PaginationV3, {
            pagination: _ctx.pagination,
            "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => (_ctx.pagination = $event)),
            onSetPage: _ctx.onSetPage,
            renderedData: _ctx.renderedData,
            paginationWidth: "w-full",
            paginationPaddingVertical: "py-2"
          }, null, 8, ["pagination", "onSetPage", "renderedData"])
        ]))
      : _createCommentVNode("", true)
  ], 4))
})